import React from "react";
import {Unless} from 'react-if';
import styles from './AdInfo.module.scss';


export interface IAdInfoProps {
  className?: string;
  title?: string;
  hideTitle?: boolean;
  children?: any;
}

const AdInfo = (props: Partial<IAdInfoProps>) => (
  <div className={`${styles.AdInfo} ${props.className}`}>
    <Unless condition={!!props.hideTitle}>{() => <>
      <div className="title">{props.title}</div>
    </>}
    </Unless>
    {props.children}
  </div>
);

AdInfo.defaultProps = {
  title: 'מידע:',
  className: '',
  children: null,
};

export default AdInfo;
